import { render, staticRenderFns } from "./queOfrece.vue?vue&type=template&id=1a73d0ea&scoped=true&lang=pug"
import script from "./queOfrece.vue?vue&type=script&lang=js"
export * from "./queOfrece.vue?vue&type=script&lang=js"
import style0 from "./queOfrece.vue?vue&type=style&index=0&id=1a73d0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73d0ea",
  null
  
)

export default component.exports